export function isObjectsEquivalent(value, other) {
  // Get the value type
  const type = Object.prototype.toString.call(value);

  // If the two objects are not the same type, return false
  if (type !== Object.prototype.toString.call(other)) {
    return false;
  }

  // If items are not an object or array, return false
  if (
    ![
      "[object Array]",
      "[object Object]",
      "[object Null]",
      "[object Undefined]"
    ].includes(type)
  ) {
    return false;
  }

  // Compare the length of the length of the two items
  let valueLen, otherLen;
  if (type === "[object Array]" || type === "[object Object]") {
    valueLen =
      type === "[object Array]" ? value.length : Object.keys(value).length;
    otherLen =
      type === "[object Array]" ? other.length : Object.keys(other).length;
    if (valueLen !== otherLen) {
      return false;
    }
  }

  // Compare two items
  const compare = function(item1, item2) {
    // Get the object type
    const itemType = Object.prototype.toString.call(item1);

    if (["[object Array]", "[object Object]"].includes(itemType)) {
      // If an object or array, compare recursively
      if (!isObjectsEquivalent(item1, item2)) {
        return false;
      }
    } else {
      // Otherwise, do a simple comparison

      // If the two items are not the same type, return false
      if (itemType !== Object.prototype.toString.call(item2)) {
        return false;
      }

      // Else if it's a function, convert to a string and compare
      // Otherwise, just compare
      if (itemType === "[object Function]") {
        if (item1.toString() !== item2.toString()) {
          return false;
        }
      } else if (item1 !== item2) {
        return false;
      }
    }
  };

  // Compare properties
  if (type === "[object Array]") {
    for (let i = 0; i < valueLen; i++) {
      if (
        other.findIndex(
          otherItem => JSON.stringify(otherItem) === JSON.stringify(value[i])
        ) === -1
      ) {
        return false;
      }
    }
  } else if (type === "[object Object]") {
    for (const key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        if (compare(value[key], other[key]) === false) {
          return false;
        }
      }
    }
  }

  // If nothing failed, return true
  return true;
}
